import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Icon } from 'gu-ui-kit'
import { TOGGLE_PANEL } from 'modules/Tickets/types'
import styles from 'components/Header/subcomponents/TicketsCounter/ticket-notifications.module.scss'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'
import { useTranslation } from 'react-i18next'

const TicketsCounter = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { ticketsCounter } = useSelector(({ app }) => app)
  const { fb } = useBreakpoint()

  return (
    <Button
      className={styles['tickets-button']}
      variant={'ghost'}
      grey
      size={fb ? 'm' : 's'}
      title={t('tickets::header')}
      startIcon={<Icon name={'messages'} />}
      onClick={() => dispatch({ type: TOGGLE_PANEL, payload: true })}
      additionalIcon={ticketsCounter > 0 && <span className="unread">{ticketsCounter}</span>}
    />
  )
}

export default TicketsCounter
